import React from 'react';
import classNames from './style.module.scss';

interface DocumentNumberPreviewProps {
	documentNumber: string;
}

const DocumentNumberPreview: React.FC<DocumentNumberPreviewProps> = ({ documentNumber }) => {
	return (
		<div className={classNames.preview}>
			Document Number: <span>{documentNumber}</span>
		</div>
	);
};

export default DocumentNumberPreview;
